import { render, staticRenderFns } from "./SampleQuestions.vue?vue&type=template&id=153e1402&scoped=true&"
import script from "./SampleQuestions.vue?vue&type=script&lang=js&"
export * from "./SampleQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SampleQuestions.vue?vue&type=style&index=0&id=153e1402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e1402",
  null
  
)

export default component.exports